<template>
    <v-container>
        <v-row v-if="!initializing && stat?.data">
            <!-- Data -->
            <v-col class="px-4 pb-0" cols="7">
                <div
                    class="font-weight-bold soli-grey"
                    :class="$vuetify.breakpoint.smAndUp ? 'body-2' : 'caption'"
                >
                    {{
                        stat?.chartData?.options?.find(
                            (e) => e.key == selectOption
                        )?.description ?? stat.data.description
                    }}
                </div>
                <div
                    v-if="stat.data.valid"
                    class="headline flex soli-grey"
                    :class="stat.data.color"
                >
                    {{ stat.data.value }}
                </div>
                <div v-if="!stat.data.valid" class="pt-2">
                    <small
                        class="flex soli-grey text-align-center font-weight-bold"
                        >Not enough data</small
                    >
                </div>
            </v-col>

            <!-- Comparisons -->
            <v-col
                class="pt-4 pl-0 pb-0"
                cols="5"
                style="min-height: 76px"
                :class="{ invisible: stat.data.hide_comparisons }"
            >
                <div
                    v-for="comp in stat.data.comparisons"
                    class="flex flex-col align-end whitespace-no-wrap"
                >
                    <small
                        v-if="comp.value"
                        class="soli-grey caption flex text-align-end"
                        >{{ comp.value }}
                        <v-icon small :class="comp.color">
                            {{ comp.icon }}
                        </v-icon>
                    </small>
                </div>
            </v-col>
        </v-row>

        <v-row v-if="!initializing && !stat?.data">
            <v-col class="flex justify-center align-center">
                <small class="soli-grey text-align-center font-weight-bold"
                    >Not enough data</small
                >
            </v-col>
        </v-row>

        <!-- Chart -->
        <v-row v-if="!initializing && stat?.data" class="mt-0">
            <v-col class="pa-0">
                <TeacherStatsChart
                    v-if="stat.data.chart_view"
                    :chartData="stat.chartData"
                    :loading="loading"
                    @reset="$emit('reset')"
                    @selectOption="getData($event)"
                />
                <v-container v-else>
                    <v-card-subtitle class="soli-grey"
                        >Year-to-Date Hours</v-card-subtitle
                    >
                    <div class="text-lg px-4 soli-grey">
                        {{ stat.data.subvalues?.ytdHours }}
                    </div>
                    <v-card-subtitle class="soli-grey"
                        >Certification Progress</v-card-subtitle
                    >
                    <StatProgress
                        :value="Number(stat.data.subvalues?.allLocationHours)"
                        :min="stat.data.min"
                        :max="stat.data.max"
                        :minLabel="stat.data.min_label"
                        :maxLabel="stat.data.max_label"
                    />
                </v-container>
            </v-col>
        </v-row>

        <v-row v-if="initializing">
            <v-col
                style="min-height: 304px"
                class="flex justify-center align-center"
            >
                <v-progress-circular
                    indeterminate
                    color="primary"
                ></v-progress-circular>
            </v-col>
        </v-row>

        <!-- Help -->
        <SoliResponsiveDialog
            v-if="showStatsHelp"
            :title="`About ${stat.data.description}`"
            @reset="$emit('reset')"
            ><template #body>
                <v-card-text class="pt-0" style="white-space: pre-line">{{
                    stat.data.help
                }}</v-card-text>
            </template>
        </SoliResponsiveDialog>
    </v-container>
</template>

<script>
import TeacherStatsChart from "./TeacherStatsChart.vue";
import StatProgress from "../Reports/StatProgress.vue";

export default {
    props: {
        teacher: {
            type: Object,
            default: () => {},
        },
        showStatsHelp: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
        },
        defaultOption: {
            type: String,
        },
    },
    components: {
        TeacherStatsChart,
        StatProgress,
    },
    data() {
        return {
            stat: null,
            chartRendered: false,
            loading: false,
            selectOption: null,
            timeout: null,
            initializing: false,
        };
    },

    methods: {
        getData(option = "") {
            this.loading = true;
            this.selectOption = option;

            axios
                .get(
                    `/api/users/teacher-performance/${
                        this.teacher.id
                    }/${this.title.toLowerCase()}/${option}`
                )
                .then((response) => {
                    this.stat = response.data;
                    this.$emit("rendered");
                    this.clearTimer();
                    this.loading = false;
                });
        },
        setTimer() {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.initializing = true;
            }, 150);
        },
        clearTimer() {
            clearTimeout(this.timeout);
            this.initializing = false;
        },
    },
    mounted() {
        this.getData(this.defaultOption);
        this.setTimer();
    },
};
</script>
